export default "__VITE_ASSET__N0FabMMF__"